import { useQuery } from '@tanstack/react-query';
import { permissionApi } from '../api/permission.api';
import { permissionKeys } from '../api/permission.keys';

export function usePermissions() {
  return useQuery({
    queryKey: permissionKeys.list(),
    queryFn: permissionApi.list,
  });
}
